<template>
  <div class="customer loader-container">
    <div v-if="customer">
      <CurrVersions />
      <h1>{{ customer.customerName }}</h1>
      <div>
        <div>{{ customer.type }}</div>
        <div>{{ customer.currentVersion }}</div>
        <div>
          <select v-model="customer.targetVersion">
            <option>Alpha</option>
            <option>Beta</option>
            <option>Release</option>
            <option>Stable</option>
          </select>
          <button @click.prevent="updateCustomer">Update</button>
        </div>
        <Loader :loading="updating" />
      </div>
      <div class="actions loader-container">
        <button @click.prevent="triggerUpdate">Trigger Version Update</button>
        <button @click.prevent="triggerConfigureIIS">
          Trigger Configure IIS
        </button>
        <button @click.prevent="triggerDatabaseBackup">
          Trigger Database Backup
        </button>
        <button @click.prevent="triggerDatabaseCopyToTest">
          Trigger Database Copy to Test
        </button>
        <Loader :loading="processingAction" />
      </div>
      <customer-current-info :customerId="customerId" />
      <customer-jobs :customerId="customerId" :refresh="refreshJobs" />
      <customer-components :customerId="customerId" />
    </div>
    <Loader :loading="loadingCustomer" />
  </div>
</template>

<script>
import service from "@/services/service.js";
import Loader from "@/components/Loader.vue";
import CustomerCurrentInfo from "../components/CustomerCurrentInfo.vue";
import CustomerComponents from "../components/CustomerComponents.vue";
import CustomerJobs from "../components/CustomerJobs.vue";
import CurrVersions from "@/components/CurrVersions.vue";

export default {
  components: {
    Loader,
    CustomerCurrentInfo,
    CustomerComponents,
    CustomerJobs,
    CurrVersions
  },
  props: {
    customerId: { type: String, default: null }
  },
  data() {
    return {
      customer: null,
      loadingJobs: false,
      loadingCustomer: false,
      processingAction: false,
      updating: false,
      refreshJobs: 0
    };
  },
  created() {
    this.getCustomer();
  },
  methods: {
    getCustomer() {
      var self = this;

      self.loadingCustomer = true;
      service
        .getCustomer(self.customerId)
        .then(response => {
          self.customer = response.data;
          self.loadingCustomer = false;
        })
        .catch(() => {
          self.loadingCustomer = false;
          self.customer = {
            customerName: "error",
            type: "error",
            currentVersion: "error",
            targetVersion: "error"
          };
        });
    },
    updateCustomer() {
      var self = this;
      self.updating = true;
      service
        .updateCustomer(this.customer)
        .then(() => {
          self.$store.dispatch("addMessage", {
            message: "Customer Updated",
            timeout: true
          });
          self.updating = false;
        })
        .catch(() => {
          self.processingAction = false;
        });
    },
    triggerUpdate() {
      var self = this;
      self.processingAction = true;
      service
        .createJobBatch(this.customer, "UPDATESITE")
        .then(() => {
          self.$store.dispatch("addMessage", {
            message: "UPDATESITE Jobs Created",
            timeout: true
          });

          this.refreshJobs += 1;
          self.processingAction = false;
        })
        .catch(() => {
          self.processingAction = false;
        });
    },
    triggerConfigureIIS() {
      var self = this;
      self.processingAction = true;
      service
        .createJobBatch(this.customer, "CONFIGUREIIS")
        .then(() => {
          self.$store.dispatch("addMessage", {
            message: "CONFIGUREIIS Jobs Created",
            timeout: true
          });

          this.refreshJobs += 1;
          self.processingAction = false;
        })
        .catch(() => {
          self.processingAction = false;
        });
    },
    triggerDatabaseBackup() {
      var self = this;
      self.processingAction = true;
      service
        .createJobBatch(this.customer, "BACKUP")
        .then(() => {
          self.$store.dispatch("addMessage", {
            message: "BACKUP Jobs Created",
            timeout: true
          });

          this.refreshJobs += 1;
          self.processingAction = false;
        })
        .catch(() => {
          self.processingAction = false;
        });
    },
    triggerDatabaseCopyToTest() {
      var self = this;
      self.processingAction = true;
      service
        .createJobBatch(this.customer, "COPYTOTEST")
        .then(() => {
          self.$store.dispatch("addMessage", {
            message: "COPYTOTEST Jobs Created",
            timeout: true
          });
          this.refreshJobs += 1;
          self.processingAction = false;
        })
        .catch(() => {
          self.processingAction = false;
        });
    }
  }
};
</script>
